import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { auth, firestore } from '../../config/firebase';
import { signIn } from '../../store/actions/authActions';
import { fetchUser } from '../../store/actions/userActions';
import { fetchProducts } from '../../store/actions/productActions';
import { fetchExpenses } from '../../store/actions/expenseActions';
import { fetchSalesList } from '../../store/actions/saleActions';
import { fetchNotifications } from '../../store/actions/notificationActions';
import { fetchSellersList } from '../../store/actions/sellerActions';
import Spinner from '../UIComponents/Spinner';
import admin from './assets/admin.svg';
import seller from './assets/seller.svg';
import manager from './assets/manager.svg';
import Swal from 'sweetalert2';
import './Auth.css';

class SignIn extends Component {
    state = {
        email: 'admin@example.com',
        password: 'password',
        msg: {
            msg: '',
            msgType: 'success',
            msgStatus: false,
            email: ''
        },
        userType: 'users',
        display: 'none',
        isActive: true,
    }

    changeInputHandler = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    userTypeHandler = (e) => {
        e.preventDefault();
        const { value } = e.target;
        this.setState({ userType: value, isActive: true });
    }

    signInHandler = async (e) => {
        e.preventDefault();

        const { email, password, userType } = this.state;
        this.setState({ display: 'flex' });

        firestore
            .collection(userType !== 'users' ? 'sellers' : 'users')
            .where('email', '==', email)
            .get()
            .then(doc => {
                if (doc.size === 0) {
                    this.setState({ emailNotFound: "Sorry! Accound doesn't exist", emailStatus: true, display: 'none' });
                } else {
                    this.setState({ emailNotFound: "", emailStatus: false });
                    const currentUser = doc.docs[0].data();
                    const { uid, displayName, id } = currentUser;
                    let promisStatus = false;
                    // Sign in for admins
                    if (userType === 'users') {

                        auth
                            .signInWithEmailAndPassword(email, password)
                            .then(async (snapShot) => {
                                //@params - uid, isLogged, email, isAdmin, displayName
                                await this.props.signIn({ uid, email, isLogged: true, isAdmin: true, userType: 'admin', displayName });
                                await this.props.fetchUser({ ...currentUser });

                                const db = firestore.doc('users/' + uid || id);

                                db.collection('products').get().then(data => {
                                    const products = data.docs.map(item => ({ id: item.id, ...item.data() }));
                                    this.props.fetchProducts(products);
                                });

                                db.collection('sales').get().then(data => {
                                    const sales = data.docs.map(item => ({ id: item.id, ...item.data() }));
                                    this.props.fetchSales(sales);
                                });

                                db.collection('notifications').get().then(data => {
                                    const notifications = data.docs.map(item => ({ id: item.id, ...item.data() }));
                                    this.props.fetchNotifications(notifications);
                                });

                                db.collection('sellers').get().then(data => {
                                    const sellers = data.docs.map(item => ({ id: item.id, ...item.data() }));
                                    this.props.fetchSellers(sellers);
                                });

                                db.collection('expenses').get().then(data => {
                                    const expenses = data.docs.map(item => ({ id: item.id, ...item.data() }));
                                    this.props.fetchExpenses(expenses);
                                });

                                // this.setState({ display: 'none' });

                                return promisStatus = true;

                            })
                            .catch(err => {
                                this.setState({ display: 'none' });
                                Swal.fire({
                                    type: 'error',
                                    // title: 'Oops...',
                                    text: err.message,
                                    showCloseButton: true,
                                });
                                return promisStatus = false;
                            })
                            .finally(() => {
                                if (promisStatus) {
                                    // After fetching redirect to home page
                                    this.props.history.push('/products');
                                }

                            })

                    } else if (userType === 'sellers' && currentUser.type === 'seller') {
                        // Sign in for sellers

                        auth
                            .signInWithEmailAndPassword(email, password)
                            .then(async (snapShot) => {
                                //@params - uid, isLogged, email, isAdmin, displayName
                                await this.props.signIn({ uid: currentUser.storeId, email, isLogged: true, isAdmin: false, userType: 'seller', displayName });
                                await this.props.fetchUser({ id: currentUser.storeId, uid: currentUser.storeId, active: true });

                                const db = firestore.doc('users/' + currentUser.storeId);

                                db.collection('products').get().then(data => {
                                    const products = data.docs.map(item => ({ id: item.id, ...item.data() }));
                                    this.props.fetchProducts(products);
                                });

                                db.collection('sales').get().then(data => {
                                    const sales = data.docs.map(item => ({ id: item.id, ...item.data() }));
                                    this.props.fetchSales(sales);
                                });

                                promisStatus = true;

                            })
                            .catch(err => {
                                this.setState({ display: 'none' });
                                Swal.fire({
                                    type: 'error',
                                    // title: 'Oops...',
                                    text: err.message,
                                    showCloseButton: true,
                                });
                                promisStatus = false;
                            })
                            .finally(() => {
                                if (promisStatus) {
                                    // After fetching redirect to home page
                                    this.props.history.push('/products');
                                }
                            })

                    } else if (userType === 'managers' && currentUser.type === 'manager') {
                        // Sign in for Managers

                        auth
                            .signInWithEmailAndPassword(email, password)
                            .then(async (snapShot) => {
                                //@params - uid, isLogged, email, isAdmin, displayName
                                await this.props.signIn({ uid: currentUser.storeId, email, isLogged: true, isAdmin: true, userType: 'manager', displayName });

                                const db = firestore.doc('users/' + currentUser.storeId);
                                await db.get().then(doc => {
                                    this.props.fetchUser({ ...doc.data() });
                                })
                                const allDB = Promise.all([
                                    db.collection('products').get(),
                                    db.collection('sales').get(),
                                    db.collection('notifications').get(),
                                    db.collection('sellers').get(),
                                ]);

                                allDB
                                    .then(data => {
                                        const products = data[0].docs.map(item => ({ id: item.id, ...item.data() }));
                                        const sales = data[1].docs.map(item => ({ id: item.id, ...item.data() }));
                                        const notifications = data[2].docs.map(item => ({ id: item.id, ...item.data() }));
                                        const sellers = data[3].docs.map(item => ({ id: item.id, ...item.data() }));

                                        this.props.fetchProducts(products);
                                        this.props.fetchSales(sales);
                                        this.props.fetchNotifications(notifications);
                                        this.props.fetchSellers(sellers);

                                        this.setState({ display: 'none' });

                                        // After fetching redirect to sale page
                                        this.props.history.push('/');
                                    })
                                    .catch(err => {
                                        Swal.fire({
                                            type: 'error',
                                            // title: 'Oops...',
                                            text: err.message,
                                            showCloseButton: true,
                                        })
                                    });


                            })
                            .catch(err => {
                                this.setState({ display: 'none' });
                                Swal.fire({
                                    type: 'error',
                                    // title: 'Oops...',
                                    text: err.message,
                                    showCloseButton: true,
                                })
                            }); // SignInWithEmailPassword Ends here
                    } else {
                        this.setState({ display: 'none' });
                        Swal.fire({
                            type: 'error',
                            // title: 'Oops...',
                            text: 'Sorry, you have entered wrong information.',
                            showCloseButton: true,
                        })
                    }


                }
            })
            .catch(err => {
                this.setState({ display: 'none' });

                Swal.fire({
                    type: 'error',
                    // title: 'Oops...',
                    text: err.message,
                    showCloseButton: true,
                })
            });

    }

    alertMessageHandler = () => {
        this.setState({ msg: { msgStatus: false } });
    }

    render() {
        return (
            <div className="container d-flex h-100 my-5 py-5 flex-column text-center align-items-center justify-content-center" id="sign-in-page">
                <Spinner display={this.state.display} />
                <div
                    className={`alert alert-${this.state.msg.msgType} mb-5`}
                    style={{ display: this.state.msg.msgStatus ? 'block' : 'none' }}
                >
                    <strong>{this.state.msg.msg}</strong>
                    <button type="button" className="close" onClick={() => this.alertMessageHandler()}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <h3 className="mt-5">Sign In Please</h3>

                {/* ======= User type handler =========== */}
                <div className="row my-4 d-flex flex-column flex-sm-row justify-content-center">
                    <button
                        className={`btn btn-outline-primary btn-lg m-2 ${this.state.userType === 'users' ? 'active' : ''}`}
                        onClick={this.userTypeHandler}
                        value="users"
                    >
                        <img src={admin} alt="Admin" width="40" />Admin
                    </button>
                    <button
                        className={`btn btn-outline-warning btn-lg m-2 ${this.state.userType === 'sellers' ? 'active' : ''}`}
                        onClick={this.userTypeHandler}
                        value="sellers"
                    >
                        <img src={seller} alt="Seller" width="40" />Seller
                    </button>
                    <button
                        className={`btn btn-outline-success btn-lg m-2 ${this.state.userType === 'managers' ? 'active' : ''}`}
                        onClick={this.userTypeHandler}
                        value="managers"
                    >
                        <img src={manager} alt="Manager" width="40" />Manager
                    </button>
                </div>

                {/* ======= Form starts here ========== */}
                <div className={this.state.isActive ? 'show' : 'd-none'} id="sign-in-form">
                    <form className="" autoComplete={'off'}>
                        <div className="form-group text-left">
                            <label htmlFor="email" className="d-flex"><span>Email</span> <small className={`ml-auto text-danger ${this.state.emailStatus ? 'd-block' : 'd-none'}`}>{this.state.emailNotFound}</small></label>
                            <input type="password" hidden name="password-hide" />
                            <input type="email" hidden name="email-hide" />
                            <input
                                type="email"
                                className={`form-control ${this.state.emailStatus ? 'border-danger' : ''}`}
                                placeholder="Enter email"
                                name="email"
                                onChange={(event) => this.changeInputHandler(event)}
                                defaultValue={this.state.email}
                            />
                        </div>

                        <div className="form-group text-left">
                            <label htmlFor="password">Password</label>

                            <input
                                type="password"
                                className="form-control"
                                placeholder="Password"
                                name="password"
                                defaultValue={this.state.password}
                                onChange={(event) => this.changeInputHandler(event)}
                                autoComplete="off"
                            />
                        </div>
                        {/* <div className="text-left my-4" style={{ display: this.state.userType === 'users' ? 'block' : 'none' }}>
                            <i>If you are new </i><Link to="sign-up">Sign Up</Link> now!
                        </div> */}
                        <button type="submit" className="btn btn-primary" onClick={this.signInHandler}>Sign In</button>
                    </form>
                </div>

            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.auth
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchUser: (data) => dispatch(fetchUser(data)),
        fetchSales: (sales) => dispatch(fetchSalesList(sales)),
        fetchSellers: (sellers) => dispatch(fetchSellersList(sellers)),
        fetchNotifications: (notifications) => dispatch(fetchNotifications(notifications)),
        fetchProducts: (products) => dispatch(fetchProducts(products)),
        signIn: (uid, email, isLogged, isAdmin, displayName) => dispatch(signIn(uid, email, isLogged, isAdmin, displayName)),
        fetchExpenses: (data) => dispatch(fetchExpenses(data))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SignIn));